import React from 'react';
import './BlogPage.css';
import Navbar from '../Shared/Navbar';
import Footer from '../Home/Footer/Footer';

const BlogPage = () => {
    return (
        <main>
            <Navbar/>
            <section className="blogpage mt-5 pt-5">
                <h1 className='text-center text-white mt-5 pt-5'> Coming Soon</h1>
            </section>
            <Footer/>
        </main>
    );
};

export default BlogPage;